import React, { Component, Fragment } from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import DraggableModal from "./DraggableModal";
import Datagrid from "./Datagrid";
import { Tree, Row, Col, Icon, Empty, Divider, Popconfirm } from "antd";
import "./DatagridModal.css";
const { TreeNode } = Tree;

class DatagridModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: [],
      groupStatus: [],
      categorySelected: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.dataSource !== prevProps.dataSource) {
      if (Object.keys(this.props.dataSource).length > 0) {
        this.setState({
          status: Object.keys(this.props.dataSource).map((i) => ({
            status: "unchecked",
          })),
        });
      }
    }
    // if (this.props.dataGroupSource !== prevProps.dataGroupSource) {
      if (Object.keys(this.props.dataGroupSource).length > this.state.groupStatus.length || Object.keys(this.props.dataGroupSource).length < this.state.groupStatus.length) {
        this.setState({
          groupStatus: Object.keys(this.props.dataGroupSource).map((group) => ({
            status: "unchecked",
          })),
        });
      }
      if(Object.keys(this.props.dataGroupSource).length === 0 && this.state.groupStatus.length > 0){
        this.setState({
          groupStatus:[]
        })
      }
    // }
  }

  renderTreeNodes = (dataSource, renderPermission, childrenCheckable) =>
    dataSource.map((item, index) => {
      if (item.children) {
        return (
          <TreeNode
            key={item.id}
            title={
              <Fragment>
                {item.name}{" "}
                {typeof renderPermission == "function"
                  ? renderPermission(item)
                  : ""}
              </Fragment>
            }
          >
            {this.renderTreeNodes(
              item.children,
              renderPermission,
              childrenCheckable
            )}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          checkable={childrenCheckable}
          key={item.id}
          title={
            <Fragment>
              {item.name}{" "}
              {typeof renderPermission == "function"
                ? renderPermission(item)
                : ""}
            </Fragment>
          }
        />
      );
    });

  limitText = (text, limit) => {
    if (text.length <= limit) {
      return text;
    } else {
      return text.slice(0, limit) + "...";
    }
  };

  onAppClickEvent = (selectedAppName, selectedAppIndex) => {
    const {
      appsOptions: { onAppsChange, onAppsGroupChange },
    } = this.props;

    this.setState((prevState) => {

      const newGroupStatus = prevState.groupStatus.map((item) => {
        if(item.status = "checked"){
            item.status= "unchecked" ;
            return item
        }
        return item
      });
      const newStatus = prevState.status.map((state, stateIndex) => {
        if (stateIndex === selectedAppIndex) {
          const currentState =
            state.status === "checked" ? "unchecked" : "checked";
          return { status: currentState };
        } else {
          return { status: "unchecked" };
        }
      });

      let selectedItem = -1;
      newStatus.forEach((state, stateIndex) => {
        if (state.status == "checked") {
          selectedItem = stateIndex;
        }
      });
      onAppsGroupChange("", "", {});
      onAppsChange(selectedItem > -1 ? selectedAppIndex : "", selectedAppName);
      return { status: newStatus, groupStatus: newGroupStatus };
    });
  };

  onGroupClickEvent = (selectedGroupName, selectedGroupIndex) => {
    const {
      appsOptions: { onAppsGroupChange, onAppsChange },
      dataGroupSource,
    } = this.props;

    this.setState((prevState) => {

      const newAppStatus = prevState.status.map((item) => {
        if(item.status = "checked"){
          item.status= "unchecked" ;
          return item
        }
        return item
      });

      const { groupStatus } = prevState;
      const newStatus = groupStatus.map((state, stateIndex) => {
        if (stateIndex === selectedGroupIndex) {
          const currentState =
            state.status === "checked" ? "unchecked" : "checked";
          const selectedGroup =
            currentState === "checked"
              ? dataGroupSource[selectedGroupIndex]
              : {};
          onAppsChange("", "");
          onAppsGroupChange(
            currentState === "checked" ? selectedGroupIndex : "",
            selectedGroupName,
            selectedGroup
          );
          return { status: currentState };
        }
        return { status: "unchecked" };
      });

      return { groupStatus: newStatus, status: newAppStatus };
    });
  };

  render() {
    const {
      cancelText,
      onSave,
      onCancel,
      saveText,
      title,
      titlePrefix,
      visible,
      type,
      width,
      height,
      footer,
    } = this.props;

    let content = {};
    if (visible) {
      if (["apps", "browsers"].includes(type)) {
        const {
          id,
          dataSource,
          originalDataSource,
          datagridOptions,
          filters,
          appsOptions: { onAppsChange, appsActive, controls, selectOptions },
          loading,
          readOnly,
        } = this.props;
        let originalData = originalDataSource;
        originalData = originalData ? originalData : dataSource;
        let itemSource = [];
        if (selectOptions == "selected")
          itemSource = itemSource.filter((n) =>
            datagridOptions.rowSelection.selectedRowKeys.includes(n.id)
          );
        if (readOnly)
          itemSource = itemSource.filter((n) =>
            datagridOptions.rowSelection.selectedRowKeys.includes(n.id)
          );

        if (typeof appsActive == "string") {
          Object.keys(dataSource).map((i) =>
            dataSource[i].item
              .filter((i) =>
                i.name.toLowerCase().includes(filters.toLowerCase())
              )
              .map((y) => itemSource.push(y))
          );
        } else {
          if (
            dataSource != null &&
            Object.keys(dataSource).length > 0 &&
            typeof appsActive == "number"
          ) {
            itemSource = dataSource[
              Object.keys(dataSource)[appsActive]
            ].item.filter((i) =>
              i.name.toLowerCase().includes(filters.toLowerCase())
            );
          }
        }
        content = (
          <Row gutter={16} style={{ height: 490 }}>
            <Col span={14}>
              <Row className="ui-datagrid-modal" gutter={8}>
                {Object.keys(dataSource).map((category, i) => {
                  const appTotal = dataSource[category].item.filter((n) =>
                    datagridOptions.rowSelection.selectedRowKeys.includes(n.id)
                  ).length;
                  const appValue = originalData[category].item.length;
                  return (
                    <Col
                      key={i}
                      span={4}
                      className={`app-icon ${type} ${
                        typeof appsActive == "number" && appsActive == i
                          ? "app-active"
                          : ""
                      }`}
                      onClick={() => {
                        if (this.state.status[i].status == "checked") {
                          onAppsChange("");
                          this.setState({
                            status: {
                              ...this.state.status,
                              [i]: { status: "unchecked" },
                            },
                          });
                        } else {
                          onAppsChange(i);
                          this.setState({
                            status: {
                              ...this.state.status,
                              [i]: { status: "checked" },
                            },
                          });
                        }
                      }}
                    >
                      <span className="app-badge">
                        <span
                          className="app-badge-total"
                          style={{
                            background:
                              appTotal == appValue
                                ? "#008000"
                                : appTotal > 0
                                ? "#ffa500"
                                : undefined,
                          }}
                        >
                          {appTotal == appValue ? (
                            <Icon type="check" />
                          ) : (
                            appTotal
                          )}
                        </span>
                        <span
                          className="app-badge-value"
                          style={{
                            background:
                              appTotal == appValue
                                ? "#015f01"
                                : appTotal > 0
                                ? "#b57500"
                                : undefined,
                          }}
                        >
                          {appValue}
                        </span>
                      </span>
                      <i
                        className={`app-icon-symbol fa ${
                          dataSource[category].icon || "fa-laptop"
                        }`}
                      />
                      {dataSource[category].name}
                    </Col>
                  );
                })}
              </Row>
            </Col>
            <Col span={10}>
              <Datagrid
                id={`datagridmodal_${id}`}
                {...datagridOptions}
                rowSelection={false ? undefined : datagridOptions.rowSelection}
                controls={controls}
                dataSource={itemSource}
                loading={loading}
                readOnly={readOnly}
              />
            </Col>
          </Row>
        );
      }
      if (type == "appsControl") {
        const {
          id,
          dataSource,
          dataGroupSource,
          dataSourceOriginal,
          datagridOptions,
          filters,
          appsOptions: {
            appsGroupActive,
            appsActive,
            controls,
            selectPermition,
            selectGroupsPermition
          },
          height,
          loading,
          deleteGroup,
          deleteGroupByRisk,
        } = this.props;
        let itemSource = [];

        if (parseInt(appsActive) > -1) {
          if (dataSource != null && Object.keys(dataSource).length > 0) {
            const activeAppKey = Object.keys(dataSource)[appsActive];

            itemSource = dataSource[activeAppKey].item.filter((i) =>
              i.name.toLowerCase().includes(filters.toLowerCase())
            );
          }
        } else if (parseInt(appsGroupActive) > -1) {
          const activeGroupKey = Object.keys(dataGroupSource)[appsGroupActive];
          if (
            dataGroupSource[activeGroupKey] &&
            dataGroupSource[activeGroupKey].categories
          ) {
            itemSource = dataGroupSource[activeGroupKey].categories.filter(
              (i) => i.name.toLowerCase().includes(filters.toLowerCase())
            );
          }
        } else {
          Object.values(dataSource).forEach((source) => {
            source.item
              .filter((i) =>
                i.name.toLowerCase().includes(filters.toLowerCase())
              )
              .forEach((y) => itemSource.push(y));
          });
        }

        content = (
          <Row gutter={16} style={{ height }}>
            <Col span={14}>
              <div
                style={{
                  maxHeight: "500px",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                <Divider orientation="left">
                  {<FormattedMessage id="applicationControl.add.category" />}
                </Divider>
                <Row className="ui-datagrid-modal" gutter={8}>
                  {Object.keys(dataSource).map((category, i) => {
                    let itemCategory = [];
                    Object.keys(dataSourceOriginal).filter(
                      (i) => (itemCategory = dataSourceOriginal[category].item)
                    );
                    itemCategory = itemCategory.map((i) => ({ id: i.id }));
                    let IdCategories = itemCategory.map((i) => i.id);
                    let controlCategory = selectPermition.filter((i) =>
                      IdCategories.includes(i.id)
                    );
                    let allowTotal = controlCategory.filter(
                      (i) => i.action == "Allow"
                    ).length;
                    let denyTotal = controlCategory.filter(
                      (i) => i.action == "Deny"
                    ).length;
                    let controlTotal = controlCategory.filter((i) => i).length;
                    return (
                      <Col
                        key={i}
                        span={4}
                        className={`app-icon appsControl ${
                          typeof appsActive == "number" && appsActive == i
                            ? "app-active"
                            : ""
                        }`}
                        onClick={() => this.onAppClickEvent(category, i)}
                      >
                        <span className="app-group-badge">
                          {dataSource[category].item[0]?.custom &&
                            <Popconfirm
                              disabled={this.props.lockFormGsmUtm}
                              title={<FormattedMessage id="applicationControl.delete.group" />}
                              onConfirm={() =>
                                deleteGroupByRisk(dataSource[category].name)
                              }
                              okText={<FormattedMessage id="common.yes" />}
                              cancelText={<FormattedMessage id="common.no" />}
                            >
                              <span className="app-group-badge-trash" >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  strokeWidth={1.5}
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                                  />
                                </svg>
                              </span>
                            </Popconfirm>
                          }
                          <div className="app-badge-absolute">
                            <div className="app-badge-numbers">
                              <span
                                className="app-group-badge-total"
                                style={{
                                  background:
                                    denyTotal == controlTotal && controlTotal > 0
                                      ? undefined
                                      : denyTotal > 0
                                      ? "#c93e3e"
                                      : undefined,
                                }}
                              >
                                {denyTotal == controlTotal && controlTotal > 0
                                  ? denyTotal
                                  : allowTotal == controlTotal && controlTotal > 0
                                  ? allowTotal
                                  : denyTotal}
                              </span>
                              <span
                                className="app-group-badge-value"
                                style={{
                                  background:
                                    allowTotal == controlTotal && controlTotal > 0
                                      ? "#008000"
                                      : denyTotal == controlTotal && controlTotal > 0
                                      ? "#db1103"
                                      : allowTotal > 0
                                      ? "#06a106"
                                      : undefined,
                                }}
                              >
                                {allowTotal == controlTotal && controlTotal > 0 ? (
                                  <Icon type="check" />
                                ) : denyTotal == controlTotal && controlTotal > 0 ? (
                                  <Icon type="close" />
                                ) : denyTotal == controlTotal && controlTotal > 0 ? (
                                  denyTotal
                                ) : (
                                  allowTotal
                                )}
                              </span>
                            </div>
                          </div>
                        </span>
                        <i
                          className={`app-icon-symbol fa ${
                            dataSource[category].icon || "fa-laptop"
                          }`}
                        />
                        {dataSource[category].name}
                      </Col>
                    );
                  })}
                </Row>
                {dataGroupSource.length > 0 && (
                  <>
                    <Divider orientation="left">
                      {<FormattedMessage id="applicationControl.add.group" />}
                    </Divider>
                    <Row className="ui-datagrid-modal" gutter={8}>
                      {Object.keys(dataGroupSource).map((category, i) => {
                        let itemCategory = [];         
                        Object.keys(selectGroupsPermition).filter((i) => {
                          const categoryPermissions = selectGroupsPermition[category];
                          if (categoryPermissions) {
                            return itemCategory = categoryPermissions.permissions;
                          }
                          return false;
                        });
                        let allowTotal = itemCategory.filter(
                          (i) => i.action.toLowerCase() === "allow"
                        ).length;
                        let denyTotal = itemCategory.filter(
                          (i) => i.action == "Deny"
                        ).length;
                        let controlTotal = itemCategory.filter(
                          (i) => i.action
                        ).length;
                        return (
                          <Col
                            key={i}
                            span={4}
                            className={`app-icon appsControl ${
                              typeof appsGroupActive == "number" &&
                              appsGroupActive == i
                                ? "app-active"
                                : ""
                            }`}
                            onClick={() => this.onGroupClickEvent(dataGroupSource[category].name, i)}
                          >
                            <span className="app-group-badge">
                              <Popconfirm
                                title={<FormattedMessage id="applicationControl.delete.group" />}
                                onConfirm={() =>
                                  deleteGroup(
                                    dataGroupSource[category].id,
                                    dataGroupSource[category].name,
                                    dataGroupSource[category].profile_appcontrol_id
                                  )
                                }
                                okText={<FormattedMessage id="common.yes" />}
                                cancelText={<FormattedMessage id="common.no" />}
                              >
                                <span className="app-group-badge-trash">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                                    />
                                  </svg>
                                </span>
                              </Popconfirm>
                              <div className="app-badge-absolute">
                                <div className="app-badge-numbers">
                                  <span
                                    className="app-group-badge-total"
                                    style={{
                                      background:
                                        denyTotal == controlTotal
                                          ? undefined
                                          : denyTotal > 0
                                          ? "#c93e3e"
                                          : undefined,
                                    }}
                                  >
                                    {denyTotal == controlTotal
                                      ? denyTotal
                                      : allowTotal == controlTotal
                                      ? allowTotal
                                      : denyTotal}
                                  </span>
                                  <span
                                    className="app-group-badge-value"
                                    style={{
                                      background:
                                        allowTotal == controlTotal
                                          ? "#008000"
                                          : denyTotal == controlTotal
                                          ? "#db1103"
                                          : allowTotal > 0
                                          ? "#06a106"
                                          : undefined,
                                    }}
                                  >
                                    {allowTotal == controlTotal ? (
                                      <Icon type="check" />
                                    ) : denyTotal == controlTotal ? (
                                      <Icon type="close" />
                                    ) : denyTotal == controlTotal ? (
                                      denyTotal
                                    ) : (
                                      allowTotal
                                    )}
                                  </span>
                                </div>
                              </div>
                            </span>
                            <i
                              className={`app-icon-symbol fa ${
                                dataGroupSource[category].fa || "fa-laptop"
                              }`}
                            />
                            {dataGroupSource[category].name}
                          </Col>
                        );
                      })}
                    </Row>
                  </>
                )}
              </div>
            </Col>

            <Col span={10} style={{ maxWidth: "100%", overflowX: "auto" }}>
              <Datagrid
                id={`datagridmodal_${id}`}
                {...datagridOptions}
                controls={controls}
                dataSource={itemSource}
                loading={loading}
              />
            </Col>
          </Row>
        );
      }

      if (type == "tree") {
        const {
          dataSource,
          treeOptions: {
            options,
            controls,
            renderPermission,
            childrenCheckable,
          },
          height,
        } = this.props;
        content = (
          <div className="ui-datagrid-modal">
            <div className="ui-datagrid-controls">{controls}</div>
            <div
              style={{
                height,
                overflowY: "auto",
                overflowX: "hidden",
                border: "1px solid #ddd",
                borderRadius: 4,
              }}
            >
              {dataSource.length > 0 && (
                <Tree checkable {...options}>
                  {this.renderTreeNodes(
                    dataSource,
                    renderPermission,
                    childrenCheckable
                  )}
                </Tree>
              )}
              {dataSource.length == 0 && (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </div>
          </div>
        );
      }
      if (type == "datagrid") {
        const { id, dataSource, loading, datagridOptions } = this.props;
        content = (
          <div className="ui-datagrid-modal" style={{ height }}>
            <Datagrid
              id={`datagridmodal_${id}`}
              {...datagridOptions}
              dataSource={dataSource}
              loading={loading}
            />
          </div>
        );
      }
    }
    return (
      <DraggableModal
        footer={footer}
        visible={visible}
        title={
          <Fragment>
            {" "}
            {titlePrefix} {title}
          </Fragment>
        }
        onOk={onSave}
        onCancel={onCancel}
        okText={saveText}
        width={width}
        cancelText={cancelText}
      >
        {visible && content}
      </DraggableModal>
    );
  }
}

DatagridModal.defaultProps = {
  id: null,
  cancelText: "Cancel",
  dataSource: [],
  dataGroupSource:[],
  loading: false,
  type: "datagrid",
  onSave: null,
  onCancel: null,
  saveText: "Save",
  title: "new registry",
  titlePrefix: "Add",
  visible: false,
  datagridOptions: {},
  treeOptions: {
    childrenCheckable: true,
  },
  appsOptions: {},
  controls: {},
  width: 520,
  height: 505,
  footer: undefined,
};

export default DatagridModal;
